<template>
    <div>
        <!-- Top row -->
        <div v-if="showSettings" class="row grid-x flex-nowrap mb-4">
            <div class="col-md-3 left-col">
                <button class="btn btn-outline-primary" @click="toggleShowSettings" style="width: 190px;">
                    {{ hideSettingsText }}
                </button>
            </div>

            <!-- Disabled fields -->
            <div class="col brd-col horisontal-pad">
                <div class="drag-area-label">{{ availableFieldsLabelText }}</div>
                <draggable v-model="internal.fields" class="d-flex flex-row drag-area flex-wrap" :class="dragAreaClass" :options="{ group: 'fields' }" @start="start" @end="end">
                    <div v-for="field in internal.fields" :key="field.key">
                        <div class="btn btn-draggable btn-secondary btn-horizontal">
                            {{ field.label }}
                        </div>
                    </div>
                </draggable>
            </div>
        </div>

        <div class="mb-4" v-else>
            <button class="btn btn-outline-primary" @click="toggleShowSettings" style="width: 190px;">
                {{ showSettingsText }}
            </button>
        </div>

        <div class="row grid-x mb-4" v-if="showSettings">
            <!-- Top left zone - TODO: renderer select menu -->
            <div class="col-md-3 left-col"></div>

            <!-- Horizontal fields -->
            <div class="col brd-col horisontal-pad">
                <div class="drag-area-label">{{ colsLabelText }}</div>
                <draggable v-model="internal.colFields" :options="{ group: 'fields' }" @start="start" @end="end" class="d-flex flex-row drag-area border-primary" :class="dragAreaClass">
                    <div v-for="field in internal.colFields" :key="field.key">
                        <div class="btn btn-draggable btn-primary btn-horizontal">
                            {{ field.label }}
                        </div>
                    </div>
                </draggable>
            </div>
        </div>

        <div class="row flex-nowrap grid-x">
            <!-- Vertical fields -->
            <div class="col-md-3 left-col" v-if="showSettings">
                <div class="brd-col">
                    <div class="drag-area-label">{{ rowsLabelText }}</div>
                    <draggable v-model="internal.rowFields" :options="{ group: 'fields' }" @start="start" @end="end" class="d-flex flex-column align-items-start drag-area border-primary" :class="dragAreaClass">
                        <div v-for="field in internal.rowFields" :key="field.key">
                            <div class="btn btn-draggable btn-primary btn-vertical">
                                {{ field.label }}
                            </div>
                        </div>
                    </draggable>
                </div>
            </div>

            <!-- Table -->
            <div class="col table-responsive">
                <pivot-table :data="data" :row-fields="internal.rowFields" :col-fields="internal.colFields" :reducer="reducer" :no-data-warning-text="noDataWarningText" :is-data-loading="isDataLoading">
                    <!-- pass down scoped slots -->
                    <template v-for="(slot, slotName) in $scopedSlots" :slot="slotName" slot-scope="{ value }">
                        <slot :name="slotName" v-bind="{ value }"></slot>
                    </template>
                    <template slot="loading">
                        <slot name="loading"></slot>
                    </template>
                </pivot-table>
            </div>
        </div>
    </div>
</template>

<script>
    import PivotTable from './PivotTable'
    import Draggable from 'vuedraggable/dist/vuedraggable.umd.min'
    export default {
        name: 'vue-pivot',
        components: { PivotTable, Draggable },
        props: {
            data: {
                type: Array,
                default: []
            },
            fields: {
                type: Array,
                default: []
            },
            rowFields: {
                type: Array,
                default: []
            },
            colFields: {
                type: Array,
                default: []
            },
            reducer: {
                type: Function,
                default: (sum, item) => sum + 1
            },
            defaultShowSettings: {
                type: Boolean,
                default: true
            },
            availableFieldsLabelText: {
                type: String,
                default: 'Available fields'
            },
            colsLabelText: {
                type: String,
                default: 'Columns'
            },
            rowsLabelText: {
                type: String,
                default: 'Rows'
            },
            hideSettingsText: {
                type: String,
                default: 'Hide settings'
            },
            showSettingsText: {
                type: String,
                default: 'Show settings'
            },
            noDataWarningText: {
                type: String,
                default: 'No data to display.'
            },
            isDataLoading: {
                type: Boolean,
                default: false
            }
        },
        data: function() {
            return {
                internal: {
                    fields: this.fields,
                    rowFields: this.rowFields,
                    colFields: this.colFields
                },
                dragging: false,
                showSettings: true
            }
        },
        computed: {
            dragAreaClass: function() {
                return this.dragging ? 'drag-area-highlight' : null
            }
        },
        methods: {
            toggleShowSettings: function() {
                this.showSettings = !this.showSettings
            },
            start: function() {
                this.dragging = true
            },
            end: function() {
                this.dragging = false
            }
        },
        created: function() {
            this.showSettings = this.defaultShowSettings
        }
    }
</script>

<style scoped>
    .brd-col {
        border: 1px dashed #1761bd;
        padding: 10px;
    }
    .btn-horizontal {
        margin: 3px 3px;
    }
    .btn-vertical {
        margin: 5px 0;
    }
    .horisontal-pad {
        margin: 0 15px;
    }

</style>


// WEBPACK FOOTER //
// src/components/PivotGrid/Pivot.vue